import { Badge, Button, Dialog, ScrollArea, Typography } from '@cannect/new-components/atoms'
import { Product } from '@cannect/new-components/molecules'
import { Skeletons } from '@cannect/new-components/organisms'
import { PropsWithChildren } from 'react'
import { useProductDetailsDialog } from './useProductDetailsDialog'

export const ProductDetailsDialogUI = ({
  productDetails,

  children
}: PropsWithChildren<ReturnType<typeof useProductDetailsDialog>>) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>
      <Dialog.Content className="flex h-full max-h-[90vh] flex-col py-6 md:max-h-[80vh]">
        {!productDetails && <Skeletons.SkeletonProductItem />}
        {productDetails && (
          <ScrollArea className="flex-1 pr-4">
            <div className="space-y-6 pb-4">
              {/* Header da modal com layout específico */}
              <div className="flex gap-4">
                <Product.HeaderImage
                  className="h-24 w-24 flex-shrink-0 sm:h-32 sm:w-32"
                  src={productDetails?.media?.filter((value) => value.format === 'IMG')?.[0]?.path}
                  alt={productDetails?.name}
                  isNationalProduct={productDetails?.supplier?.id === 18}
                  product={productDetails}
                />
                <div className="flex min-w-0 flex-1 flex-col gap-3">
                  <div>
                    <h2 className="text-base font-semibold leading-tight text-neutral-900 sm:text-lg">
                      {productDetails?.name}
                    </h2>
                    {productDetails?.medical_data?.volume && (
                      <p className="text-sm text-neutral-600 sm:text-base">
                        {productDetails.medical_data.volume}
                        {productDetails?.medical_data?.unit_of_measurement?.toLowerCase()}
                      </p>
                    )}
                    {productDetails?.brand?.name && (
                      <p className="text-sm text-neutral-500">{productDetails.brand.name}</p>
                    )}
                  </div>

                  <div className="flex flex-wrap gap-2">
                    {productDetails?.class?.name && (
                      <Badge variant="neutral" className="text-xs">
                        {productDetails?.class?.name}
                      </Badge>
                    )}
                    {productDetails?.flavor && (
                      <Badge className="bg-flavors-default-100 text-xs text-flavors-default-900">
                        {productDetails?.flavor || 'Natural'}
                      </Badge>
                    )}
                  </div>
                </div>
              </div>

              {/* Descrição do produto */}
              {productDetails?.details && (
                <div>
                  <Typography.Text type="paragraphTwo" className="whitespace-pre-line">
                    {productDetails?.details}
                  </Typography.Text>
                </div>
              )}

              {/* Ficha técnica */}
              <div>
                <Typography.Text weight="semibold" className="!mb-3 text-base">
                  Ficha técnica
                </Typography.Text>
                <div className="flex flex-col gap-4">
                  {productDetails?.general_informations &&
                    productDetails?.general_informations.map(({ title, description }) => (
                      <div key={`${title}-${description}`} className="space-y-1">
                        <Typography.Text type="paragraphTwo" weight="semibold" className="text-sm">
                          {title}
                        </Typography.Text>
                        <Typography.Text type="paragraphTwo" className="whitespace-pre-line text-sm text-neutral-600">
                          {description}
                        </Typography.Text>
                      </div>
                    ))}
                  {productDetails?.coa_url && (
                    <div className="space-y-1">
                      <Typography.Text type="paragraphTwo" weight="semibold" className="text-sm">
                        COA:
                      </Typography.Text>
                      <Button
                        unstyled
                        onClick={() => window.open(productDetails?.coa_url, '_blank')}
                        className="text-sm font-normal text-primary-700 hover:underline">
                        Fazer download do PDF
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </ScrollArea>
        )}
        <Dialog.Footer className="flex-shrink-0 border-t border-neutral-200 pt-4">
          <Dialog.Close asChild>
            <Button size="lg" className="mx-2 font-medium sm:mx-0" full>
              Fechar
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  )
}
